module.exports = __webpack_public_path__ + "static/media/pic20.c34af055.jpg";